import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { Observable } from 'rxjs';



import { UtilService } from './util-service';

@Injectable()
export class RolAssinantesService {

  constructor(http: HttpClient, private utilService: UtilService) {
  }

  public getRolAssinantes(idPCA): Observable<any> {
    let urlObtencaoDados: string = "assinante/listarPorPca?idPca=" + idPCA;
    return this.utilService.getJSON(urlObtencaoDados);
  }

  public buscarEstados(): Observable<any> {
    let urlObtencaoDados: string = "rolresponsaveis/listarEstados";
    return this.utilService.getJSON(urlObtencaoDados);
  }

  public buscarCidades(query): Observable<any> {
    let urlObtencaoDados: string = "assinante/listarCidades?query="+query;
    return this.utilService.getJSON(urlObtencaoDados);
  }

  public buscarTiposTelefone() {
    let urlObtencaoDados: string = "rolresponsaveis/listarTiposTelefone";
    return this.utilService.getJSON(urlObtencaoDados);
  }

  public buscarCargosSAP() {
    let urlObtencaoDados: string = "cargo/listarCargosSAP";
    return this.utilService.getJSON(urlObtencaoDados);
  }

  public bucarAssinantePorCpf(cpf) {
    let urlObtencaoDados: string = "assinante/buscaPorCpf/" + cpf;
    return this.utilService.getJSON(urlObtencaoDados);
  }

  public buscarCidadesPorEstado(idEstado): Observable<any> {
    let urlObtencaoDados: string = "rolresponsaveis/listarCidadesPorEstado?idEstado=" + idEstado;
    return this.utilService.getJSON(urlObtencaoDados);
  }

  public buscarEnderecoPorCEP(cep) {
    let urlObtencaoDados: string = "http://viacep.com.br/ws/" +
      cep.toString().replace('-', '') +
      "/json/";
    return this.utilService.getJSONExterno(urlObtencaoDados);
  }

  public salvarAssinante(assinante): Observable<any> {
    let urlObtencaoDados = "assinante/salvar";
    return this.utilService.postJSON(urlObtencaoDados, assinante);
  }

  public excluirAssinante(assinante): Observable<any> {
    let urlObtencaoDados = "assinante/deletar/" + assinante.idAssinante;
    return this.utilService.deleteJSON(urlObtencaoDados);
  }

  public importarAssinantes(idPCA): Observable<any> {
    let urlObtencaoDados = "assinante/importarAssinantes/" + idPCA;
    return this.utilService.postJSON(urlObtencaoDados, null);
  }
}



// WEBPACK FOOTER //
// ./src/providers/rol-assinantes-service.ts